const startConfig = require('../apiConfig')
const comHttpUrl = startConfig.baseUrl()

module.exports = {
  blob: comHttpUrl + 'file/download',
  login: comHttpUrl + 'officialuser/login',
  reset: comHttpUrl + 'officialuser/reset',
  save: comHttpUrl + 'officialuser/save',
  coderImg: `${comHttpUrl}verifycode/code?tiem=`,
  advertising: comHttpUrl + 'advertising/list'
}



// WEBPACK FOOTER //
// ./src/api/modules/user.js